/* version: 2026-10-25.1
   Aero glass settings: the ONE place the app's glass looks are set.

   This is the app's copy of the website's shared/glass-settings.js (aero-landing-page), the
   "Final, go live (25 Oct)" glass: clear refracting edge, rim light, colour pickup from every
   side, a toned-down caustic, a light frosted backing behind white glass labels, ink at 0.85,
   no wall, no shadow, radius 10.

   To change the glass: open the glass panel, press "Export for site", and copy the numbers of
   window.GLASS_P into GLASS_SETTINGS below (same keys, same values). Keep the website's file and
   this one identical, and bump the version line on both. The engine (./glassV3Engine.js) only
   reads these numbers; never tune it directly. */

export const GLASS_MODE = 'subtle';

export const GLASS_SETTINGS = {
  reach: 340,
  paleLo: 0.015,
  paleHi: 0.12,
  boost: 1.8,
  ambOut: 0.4,
  refl: 1.3,
  pick: 1.15,
  glowW: 0.26,
  glowI: 0.32,
  glowWidth: 3.2,
  causW: 0.26,
  causI: 0.2,
  causWidth: 2,
  causPos: 1.6,
  causTint: 0.8,
  causEnv: 0.7,
  causDown: 0.75,
  causPow: 1.1,
  bevel: 5,
  wall: 1.4,
  wallW: 0.3,
  wallI: 0.3,
  wallTint: 0.6,
  crestW: 0.25,
  crestI: 0.1,
  refrW: 24,
  refrI: 12,
  refrBlur: 0.3,
  refrSat: 1.8,
  keyW: 0.55,
  keyI: 0.4,
  keyTight: 3,
  followW: 0.8,
  followI: 0,
  keyHW: 0.4,
  keyHI: 0.12,
  glowHW: 0.55,
  glowHI: 0.12,
  glowSize: 1.1,
  spreadW: 0.22,
  spreadI: 0.15,
  followSpeed: 120,
  liftBend: 0.25,
  liftRim: 0.35,
  liftWall: 0,
  liftShadow: 0,
  causH: 0.5,
  whiteA: 0.16,
  inkA: 0.85,
  radius: 10,
  shadowStyle: "slab",
  shadow: 0,
  navBlur: 15,
  navA1: 0.72,
  navA2: 0.6,
  navSat: 190,
  navEdge: 3,
  navStrip: 0.5,
  navEdgeBlur: 2,
  L_refr: 1,
  L_body: 1,
  L_refl: 1,
  L_glow: 1,
  L_caus: 1,
  L_wall: 0,
  L_crest: 1,
  L_key: 1,
  L_hover: 1,
  L_shadow: 0,
  L_navFrost: 1,
  L_navStrip: 1,
  appSecondary: 1,
  rimW: 1,
  rimI: 0.35,
  volW: 0.7,
  volH: 1,
  causFloor: 0.15,
  frostBlur: 8,
  frostA: 0.5,
  frostInset: 3,
};
